module.exports = process.env.MEDIATOR_JS_COV
  ? require('./lib-cov/mediator')
  : require('./lib/mediator');



//////////////////
// WEBPACK FOOTER
// ../node_modules/mediator-js/index.js
// module id = 7
// module chunks = 0